import React, { Component } from 'react'
import { observer } from 'mobx-react'
import OrderHeader from './OrderHeader'
import OrderGeneral from './OrderGeneral'
import OrderDetail from './OrderDetail'
import ProtocolModal from './ProtocolModal'
import mStore from '../store'
@observer
export default class extends Component {
  render() {
    const {
      details: { status }
    } = mStore
    return (
      <div style={{ padding: 20 }}>
        {status == '0' && <OrderHeader />}
        <OrderGeneral />
        <OrderDetail />
        <ProtocolModal />
      </div>
    )
  }
}
